// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';


export class RestoreMapAction implements flatbuffers.IUnpackableObject<RestoreMapActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):RestoreMapAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsRestoreMapAction(bb:flatbuffers.ByteBuffer, obj?:RestoreMapAction):RestoreMapAction {
  return (obj || new RestoreMapAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsRestoreMapAction(bb:flatbuffers.ByteBuffer, obj?:RestoreMapAction):RestoreMapAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new RestoreMapAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.MapRestoreMap;
}

static startRestoreMapAction(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.MapRestoreMap);
}

static endRestoreMapAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createRestoreMapAction(builder:flatbuffers.Builder, type:ActionType):flatbuffers.Offset {
  RestoreMapAction.startRestoreMapAction(builder);
  RestoreMapAction.addType(builder, type);
  return RestoreMapAction.endRestoreMapAction(builder);
}

unpack(): RestoreMapActionT {
  return new RestoreMapActionT(
    this.type()
  );
}


unpackTo(_o: RestoreMapActionT): void {
  _o.type = this.type();
}
}

export class RestoreMapActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.MapRestoreMap
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return RestoreMapAction.createRestoreMapAction(builder,
    this.type
  );
}
}
